import { t } from '@lingui/macro';
import React, { useMemo } from 'react';
import { Button, Group, Select } from '@economic/taco';
import { format } from 'date-fns';
import Qs from 'qs';
import { useNavigate } from 'react-router-dom';
import { KVTModel, EligableJournal } from './types';
import legacyApiClient from '../../util/api/legacyApiClient';
import { Field, Form } from '../Form';

interface KVTProps {
    close: () => void;
    entryId: number;
    actionType: 0 | 1 | 2;
    initialData: KVTModel;
}

export default function KVT({ initialData, entryId, actionType, close }: KVTProps) {
    const navigate = useNavigate();

    let actionText;
    switch (actionType) {
        case 0:
            actionText = t({ message: 'Copy', id: 'kvt-copy' });
            break;
        case 1:
            actionText = t({ message: 'Turn', id: 'kvt-turn' });
            break;
        default:
            actionText = t({ message: 'Reverse', id: 'kvt-reverse' });
            break;
    }

    const data = useMemo(() => {
        return Object.keys(initialData.eligableJournals).map(key => {
            const journal = initialData.eligableJournals[key];
            return {
                data: { key: Number(key), value: journal } as EligableJournal,
                text: journal,
                value: Number(key),
            };
        });
    }, [initialData.eligableJournals]);

    const eligibleJournalDropdown = (props: any) => <Select {...props} data={data} />;

    const handleSubmit = async (values: any) => {
        const date = new Date(values.date);
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();

        const request = {
            confirmed: 'no',
            Bilagsnr: values.voucherNumber,
            BilagDag: day,
            BilagMaaned: month,
            BilagAar: year,
            BeholdTekst: values.newText,
            KasseKladde: values.journal,
            OK: 'OK',
        };

        try {
            const response = await legacyApiClient.post(
                `/bogfoering/KVTBilag.asp?KVT=${actionType}&postid=${entryId}`,
                Qs.stringify(request),
                {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                }
            );

            close();

            // Redirect to the desired URL after successful post
            navigate(`/accounting/journals/${values.journal}`);
            return response;
        } catch (error) {
            return Promise.reject(error);
        }
    };

    return (
        <Form initialData={initialData} onSubmit={handleSubmit} validateOnBlur={false}>
            <h1>
                {actionText} {t`voucher`} {initialData.voucherNumber}-{format(initialData.date, 'DD.MM.YY')}
            </h1>

            <Field.Number label={t`Voucher`} required name="voucherNumber" />
            <Field.DatePicker label={t`Date`} required name="date" />
            <Field.Text label={t`New text, if any`} name="newText" />
            <Field.Dropdown role="journal" name="journal" required label={t`Journal`} as={eligibleJournalDropdown} />
            <div className="items-end">
                <Group>
                    <Button appearance="primary" type="submit">
                        {t`OK`}
                    </Button>
                    <Button appearance="default" onClick={close}>
                        {t`Cancel`}
                    </Button>
                </Group>
            </div>
        </Form>
    );
}
